import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import about from '../../../images/my-image/borna-2.jpg';
import './About.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {

      AOS.init();

return (
    <section id="about">
        <div className="about_area mb-5">
            <Container>
                <Row className="text-sm-start">
                    <Col lg={4} md={4} sm={12}>
                        
                            <div>
                                <div className="about-img mx-5">
                                   <img className="mt-5" src={about} alt="" />
                                </div>
                            </div>
                    </Col>

                    <Col lg={6} md={6} sm={12}>
                        <div className="about-text">
                            <h2><span className="about-hi">Hi..!!</span> I'm Dilruba Jannat Borna</h2>
                            <p>I am an enthusiastic JavaScript developer with knowing some frameworks for the frontend and the backend. I  MERN developer. I always focus on learning new technology. I will finish my study in the Department of Computer Science and Engineering(CSE). University of Development Alternative (UODA), Dhaka.</p>

                            <div className='about-icon'>
                                <a href="https://github.com/JannatBorna" className="m-2" ><i className="fab fa-github"></i></a>

                                <a href="https://www.linkedin.com/in/dilruba-jannat-borna-09147b216/" className="mx-3"><i className="fab fa-linkedin"></i></a>

                                <a href="https://www.instagram.com/borna_jannat/" className="mx-3"><i class="fab fa-instagram"></i></a>

                                <a href="https://www.facebook.com/Bornabaset" className="mx-3"><i className="fab fa-facebook-square"></i></a>

                                <a href="https://twitter.com/" className="mx-3"><i className="fab fa-twitter"></i></a>
                            </div>

                        </div>
                    </Col>
                </Row>

                <Row className="mt-5 text-sm-start" >
                    <Col lg={6} md={6} sm={12}>
                        {/* <h1 className="about_skills mt-5">My Skills</h1> */}

                        <div className="text-sm-start mt-5">
                            <h2 className='about-line'>Expertise:</h2>
                            <button className="about-btn mx-2 my-2" >ReactJS</button>
                            <button className="about-btn mx-2 my-2" >React Router</button>
                            <button className="about-btn mx-2 my-2" >React Bootstrap</button>
                            <button className="about-btn mx-2 my-2" >Material UI</button>
                            <button className="about-btn mx-2 my-2" >HTML5</button>
                            <button className="about-btn mx-2 my-2" >CSS3</button>
                            <button className="about-btn mx-2 my-2" >Bootstrap</button>
                            <button className="about-btn mx-2 my-2" >JavaScript (ES6)</button>
                            <button className="about-btn mx-2 my-2" >Tailwind css</button>
                        </div>




                        <div className="text-sm-start mt-5">
                            <h2 className='about-line'>Comfortable:</h2>
                            <button className="about-btn mx-2 my-2" >ReactJs</button>
                            <button className="about-btn mx-2 my-2" >Node</button>
                            <button className="about-btn mx-2 my-2" >MongoDB</button>
                            <button className="about-btn mx-2 my-2" >React Router</button>
                            <button className="about-btn mx-2 my-2" >Firebase</button>
                        </div>


                        <div className="text-sm-start mt-5">
                            <h2 className='about-line'>Familiar:</h2>
                            <button className="about-btn mx-2 my-2">Material UI</button>
                        </div>

                        <div className="text-sm-start mt-5">
                            <h2 className='about-line'>Tools:</h2>
                            <button className="about-btn mx-2 my-2" >Heroku</button>
                            <button className="about-btn mx-2 my-2" >Netlify</button>
                            <button className="about-btn mx-2 my-2" >Firebase</button>
                            <button className="about-btn mx-2 my-2" >Chrome Dev-tool</button>
                            <button className="about-btn mx-2 my-2" >VSCode</button>
                            <button className="about-btn mx-2 my-2" >Github</button>
                        </div>

                        <div className="text-sm-start mt-5">
                            <h2 className='about-line'>Extra Skills:</h2>
                            <button className="about-btn mx-2 my-2" >Digital Marketing</button>
                            <button className="about-btn mx-2 my-2" >Data Entry</button>
                            <button className="about-btn mx-2 my-2" >Microsoft Word</button>
                            <button className="about-btn mx-2 my-2" >Microsoft Powerpoint</button>
                            <button className="about-btn mx-2 my-2" >Microsoft Excel</button>

                        </div>
                    </Col>






                    <Col lg={6} md={6} sm={12}>
                        <div className="education mt-5">
                            <div>
                                <h2 className="about-line mt-5">My Education</h2>
                                <h4>B.Sc. in Computer Science and Engineering(CSE)</h4>
                                <h5>University of Development Alternative (UODA)</h5>
                                <h6>2018 – 2021 (Graduated)</h6>
                            </div>
                        </div>

                        <div className="education mt-5">
                            <div>
                                <h2 className="about-line mt-5">My Hobby</h2>
                            <ul>
                                <li>I like to play video games</li>
                                <li>Reading books</li>
                                <li>learning something new</li>
                                <li>It's my favorite part, always self toking, It's very important for every person.</li>
                            </ul>
                            </div>
                        </div>

                    </Col>
                </Row>
            </Container>


            <footer className="sub-footer">
                <small>Frontend &copy; 2018 &#9877; DILRUBA BORNA</small>
                <br />
                <small>Dhaka, Bangladesh</small>
            </footer>

        </div>
    </section>
    );
};

export default About;


                        
                       

                        
                        